import { get, post, put, del } from './apiService';

const rankService = {
  // Get all ranks
  getRanks: async () => {
    try {
      const response = await get('admin/getranks');
      return response.data || response;
    } catch (error) {
      console.error('Error fetching ranks:', error);
      throw error;
    }
  },

  // Create a new rank
  createRank: async (rankData) => {
    try {
      const response = await post('admin/createrank', rankData);
      return response.data || response;
    } catch (error) {
      console.error('Error creating rank:', error);
      throw error;
    }
  },

  // Update an existing rank
  updateRank: async (rankData) => {
    try {
      const response = await put('admin/updaterank', rankData);
      return response.data || response;
    } catch (error) {
      console.error('Error updating rank:', error);
      throw error;
    }
  },

  // Delete a rank
  deleteRank: async (rankId) => {
    try {
      const response = await del(`admin/deleterank/${rankId}`);
      return response.data || response;
    } catch (error) {
      console.error('Error deleting rank:', error);
      throw error;
    }
  }
};

export default rankService;
